export { default as InformationCircleOutlineIcon } from './InformationCircleOutlineIcon';
